import { Multiselect } from "@wizardhealth/stimulus-multiselect";
// import Multiselect from "./portal/multiselect";
import CustomMultiselectListManage from "../packs/custom_multiselect_list_manage";

export default class extends Multiselect {
  static targets = ["multiselect"];

  connect() {
    super.connect();
    for (let index = 0; index < this.multiselectTargets.length; index++) {
      const element = this.multiselectTargets[index];
      this.initialAllSelectOption(element);

      element.addEventListener("multiselect-added", (event) => {
        this.addFromExistsValue(element, event.detail);
        this.dispatch("triggerMultiselectAddEvent", { detail: event.detail });
      });

      element.addEventListener("multiselect-change", (event) => {
        this.dispatch("triggerMultiselectChangeEvent", {
          detail: event.detail,
        });
      });

      element.addEventListener("multiselect-removed", (event) => {
        this.removedFromExistsValue(element, event.detail);
        this.toogleStyleDisplay();
        this.dispatch("triggerMultiselectRemoveEvent", {
          detail: event.detail,
        });
      });
    }

    document.addEventListener("custom-multiselect-removed", (event) => {
      this.removeCustomItem(event);
    });

    if (this.hasSelectedValue && this.selectedValue.length) {
      this.searchTargets.forEach((search) => {
        search.style.display = "none";
      });
    }
  }

  disconnect() {
    super.disconnect();
    for (let index = 0; index < this.multiselectTargets.length; index++) {
      const element = this.multiselectTargets[index];
      element.removeEventListener("multiselect-added", (event) => {
        this.dispatch("triggerMultiselectAddEvent", { detail: event.detail });
      });
      element.removeEventListener("multiselect-removed", (event) => {
        this.toogleStyleDisplay();
        this.dispatch("triggerMultiselectRemoveEvent", {
          detail: event.detail,
        });
      });
      element.removeEventListener("custom-multiselect-removed", (event) => { });
    }
    CustomMultiselectListManage("removeMainList", "", "", "");
  }

  // We need to add a specific configuration for this feature. Because sometimes we don't want to use it
  // we need to check there is already a record using override toogleItem(input) method
  // if we have an already a record we can skip, otherwise we can add
  toggleItem(input) {
    let splitted = []
    if (!Array.isArray(input.dataset.value)) {
      splitted = String(input.dataset.value).split(",")
    }
    if (splitted && splitted.length > 1) {
      super.toggleItem(input);
    } else {
      if (input.checked == false){
        super.toggleItem(input);
      } else {
        let isAddToItem = CustomMultiselectListManage("toggleItem", "", "", input);
        if (isAddToItem) {
          super.toggleItem(input);
        } else {
          this.dispatch("triggerMultiselectHasAlreadyRecord", { detail: input });
        }
      }
    }
  }

  addFromExistsValue(element, selectedValue) {
    CustomMultiselectListManage("add", element, selectedValue, "");
  }

  removedFromExistsValue(element, selectedValue) {
    CustomMultiselectListManage("remove", element, selectedValue, "");
  }

  initialAllSelectOption(element) {
    CustomMultiselectListManage("initial", element, this.selectedValue, "");
  }

  removeCustomItem(e) {
    this.listTargets;
    this.selectedItems;
  }

  toogleStyleDisplay(e) {
    this.searchTargets.forEach((item) => {
      if ((item.style.display = "none")) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  /*
  We override this selectedValueChanged and checkItem methods to select only for 'All Specimens' or 'Other Group' Options

  Like we have already this options :
    {text: 'Abdomen (AA-test) - test100 - test100-1', value: '647271'}
    {text: 'Abdomen (AA-test) - test100 - test100-2', value: '647272'}
    
    And we want to select All Specimen or any other group options. And become : 

    {text: 'Abdomen (AA-test) - test100 - test100-1', value: '647271'}
    {text: 'Abdomen (AA-test) - test100 - test100-2', value: '647272'}
    {text: 'All Specimens', value: '647271,647272,647273,647274'}

    But we want to show only All Specimens because All Specimen value has includes other options values
*/
  selectedValueChanged() {
    if (!this.hasPreviewTarget) return

    while (this.hiddenTarget.options.length) this.hiddenTarget.remove(0)

    if (this.selectedValue.length > 0) {
      this.previewTarget.innerHTML = this.pills
      this.searchTarget.style.paddingTop = "0.5rem"

      // added a new method for new implementation
      const itemsSetToUncheck = this.filterSelectedValueAndGetUncheckItems()

      this.selectedValue.forEach(selected => {
        const option = document.createElement("option")
        option.text = selected.text
        option.value = selected.value
        option.setAttribute("selected", true)
        this.hiddenTarget.add(option)
      })

      if (!this.searchRemoteValue) {
        this.selectedValue.forEach(selected => {
          this.checkItem(selected.value)
        })
        // Added this block to uncheck list items that we don't want to be checked
        const newItemsToUncheck = [...itemsSetToUncheck]
        newItemsToUncheck.forEach(value => {
          this.unCheckItem(value)
        })
      }

    } else {
      this.searchTarget.style.paddingTop = "0"
      this.inputContainerTarget.style.display = ""
      this.previewTarget.innerHTML = ""
    }

    this.element.dispatchEvent(new Event("multiselect-change"))
  }

  checkItem(value) {
    const itemToCheck = this.listTarget.querySelector(`input[data-value="${value}"]`)
    if (itemToCheck) itemToCheck.checked = true
  }

  unCheckItem(value) {
    const itemToUnCheck = this.listTarget.querySelector(`input[data-value="${value}"]`)
    if (itemToUnCheck) {
      // TODO - we can do that after
      // itemToUnCheck.disabled = true
      itemToUnCheck.checked = false
    }
  }

  filterSelectedValueAndGetUncheckItems() {
    // added a new method for new implementation
    let i = 0;
    const itemsSetToUncheck = new Set()
    while (i < this.selectedValue.length) {
      let selected = this.selectedValue[i]

      let splitted = []
      if (!Array.isArray(selected.value)) {
        splitted = String(selected.value).split(",")
      }

      if (splitted && splitted.length > 1) {
        splitted.forEach(splittedValue => {

          this.selectedValue.forEach(item => {
            if (String(item.value) !== splittedValue) {
              itemsSetToUncheck.add(splittedValue)
            }
          })

          this.selectedValue = this.selectedValue.filter(function (itemSelected) {
            return String(itemSelected.value) !== splittedValue
          })
        })
      }
      ++i;
    }

    return itemsSetToUncheck
  }
}
